/*
  Custom JS code.
*/





document.addEventListener("DOMContentLoaded", function() {
    const featureImage = document.querySelector("#shopify-section-article-template .article-img");
    if (featureImage) {
        featureImage.style.display = "none"; // Hide the feature image
    }
});
